import { render, staticRenderFns } from "./ReadOnly.vue?vue&type=template&id=62282e2c&scoped=true&"
import script from "./ReadOnly.vue?vue&type=script&setup=true&lang=js&"
export * from "./ReadOnly.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ReadOnly.vue?vue&type=style&index=0&id=62282e2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62282e2c",
  null
  
)

export default component.exports